import { Pipe, PipeTransform } from '@angular/core';
import { convertToLocalTime } from '../helpers/utils';

@Pipe({
    name: 'convertToLocalTime',
    standalone: false
})
export class ConvertToLocalTimePipe implements PipeTransform {
    /**
     * Transforms UTC time into local time using the utility function.
     * @param utcTime - The UTC timestamp string.
     * @param format - Optional format (default: "DD/MM/YYYY h:mm:ss A" for user-friendly display).
     * @returns A formatted local time string or 'N/A' if input is invalid.
     */
    transform(utcTime: string, format: string = 'DD/MM/YYYY h:mm:ss A'): string {
        if (!utcTime) return 'N/A';

        const localTime = convertToLocalTime(utcTime);
        
        return localTime ? localTime.format(format) : 'N/A';
    }
}
